export const SCROLL_TO_TOP_THRESHOLD = 400;

export function shouldShowScrollToTop(scrollY, hidden = false) {
  return !hidden && scrollY > SCROLL_TO_TOP_THRESHOLD;
}

export function subscribeToWindowScroll(targetWindow, listener) {
  targetWindow.addEventListener('scroll', listener, { passive: true });
  return () => targetWindow.removeEventListener('scroll', listener);
}

export function scrollWindowToTop(targetWindow) {
  targetWindow.scrollTo({ top: 0, behavior: 'smooth' });
}
